import {
  ADMIN_TOKEN_HEADER as DEFAULT_ADMIN_TOKEN_HEADER,
  SA_TOKEN_HEADER as DEFAULT_DEV_SA_TOKEN_HEADER,
  SA_TOKEN_HEADER_PROD as DEFAULT_PROD_SA_TOKEN_HEADER,
} from "./constants";

export type AuthHeaderEnvReader = () => string | undefined;

export type ReadAuthHeaderOptions = {
  /** Vite `import.meta.env.DEV`；true 时默认 satoken，false 时默认 Authorization */
  dev?: boolean;
};

/** 用户端 Sa-Token 请求头；`VITE_SA_TOKEN_HEADER` 可选覆盖，否则 dev→satoken / prod→Authorization */
export function readSaTokenHeader(
  getEnv?: AuthHeaderEnvReader,
  options: ReadAuthHeaderOptions = {},
): string {
  const raw = getEnv?.()?.trim();
  if (raw) return raw;
  return options.dev ? DEFAULT_DEV_SA_TOKEN_HEADER : DEFAULT_PROD_SA_TOKEN_HEADER;
}

/** 管理端 Sa-Token 请求头；默认 admin-token（与后端 glyphicai.auth.admin-token-header 一致） */
export function readAdminTokenHeader(getEnv?: AuthHeaderEnvReader): string {
  const raw = getEnv?.()?.trim();
  return raw || DEFAULT_ADMIN_TOKEN_HEADER;
}
